import { TKey } from "@/app/translations/TKey";
import { BlogCoverBar, BlogCoverDot, BlogCoverScore, BlogCoverTag } from "@/app/types/BlogCover";

const WAVE_HEIGHTS = [
  28, 52, 40, 70, 34, 88, 60, 44, 76, 30, 56, 92, 48, 66, 36, 80, 50, 42, 72, 32, 58, 46, 64, 38,
];
const WAVE_PLAYED_SHARE = 0.6;
const WAVE_SEED_STEP = 5;

const COVER_TAGS: BlogCoverTag[] = [
  { labelKey: TKey.EXCHANGE_TAG_OBJECTION, toneClass: "toneObjection" },
  { labelKey: TKey.EXCHANGE_TAG_PAIN_POINT, toneClass: "tonePain" },
  { labelKey: TKey.EXCHANGE_TAG_BUYING_REASON, toneClass: "toneSignal" },
  { labelKey: TKey.EXCHANGE_TAG_COMPETITOR_MENTION, toneClass: "toneTrends" },
  { labelKey: TKey.EXCHANGE_TAG_BUDGET, toneClass: "toneBalance" },
  { labelKey: TKey.EXCHANGE_TAG_NEXT_STEP, toneClass: "toneSpeech" },
];
const COVER_TAGS_SHOWN = 3;

const SCORE_TOTAL = 12;
const SCORE_WON_BASE = 7;
const SCORE_VARIANTS = 3;

function rotate<T>(items: T[], seed: number): T[] {
  const start = seed % items.length;
  return [...items.slice(start), ...items.slice(0, start)];
}

export function coverBars(seed: number): BlogCoverBar[] {
  const played = Math.round(WAVE_HEIGHTS.length * WAVE_PLAYED_SHARE);
  return rotate(WAVE_HEIGHTS, seed * WAVE_SEED_STEP).map((height, index) => ({
    id: `bar${index}`,
    height: `${height}%`,
    isPlayed: index < played,
  }));
}

export function coverTags(seed: number): BlogCoverTag[] {
  return rotate(COVER_TAGS, seed).slice(0, COVER_TAGS_SHOWN);
}

function scoreDots(filled: number): BlogCoverDot[] {
  return Array.from({ length: SCORE_TOTAL }, (_, index) => ({
    id: `dot${index}`,
    isFilled: index < filled,
  }));
}

export function coverScores(seed: number): BlogCoverScore[] {
  const won = SCORE_WON_BASE + (seed % SCORE_VARIANTS);
  return [
    { labelKey: TKey.DEAL_STAGE_WON, toneClass: "dotWon", dots: scoreDots(won) },
    { labelKey: TKey.DEAL_STAGE_LOST, toneClass: "dotLost", dots: scoreDots(SCORE_TOTAL - won) },
  ];
}
